(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-story"]) return;
  try {
    
  document.querySelectorAll('[data-nk-gallery]').forEach(function (gallery) {
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-gallery-thumb');
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        gallery.querySelectorAll('[data-gallery-image]').forEach(function (img) {
          img.hidden = img.getAttribute('data-gallery-image') !== idx;
        });
      });
    });
  });

  document.querySelectorAll('[data-pdp-variant-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var id = tab.getAttribute('data-pdp-variant-tab');
      tab.closest('.nk-pdp-hero__inner').querySelectorAll('[data-pdp-variant-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
      });
      tab.closest('.nk-pdp-hero__inner').querySelectorAll('[data-pdp-variant-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-pdp-variant-panel') !== id;
      });
      tab.closest('.nk-pdp-hero__inner').querySelectorAll('[data-pdp-variant-input]').forEach(function (i) {
        i.value = id;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
